import { Route, Routes } from "react-router-dom";
//import L1Issuers from "./L1Issuers/main";
import L1Events from "./L1Events/main";
import L1Portfolios from "./L1Portfolios/main";
import L1StaticData from "./L1StaticData/main";
import L1TimeSeries from "./L1TimeSeries/main";
import L1Transactions from "./L1Transactions/main";
import L1DataUpload from "./L1DataUpload/main";
import L1BankPositions from "./L1BankPositions/main";

export default function L1Routes() {
  return (
    <Routes>
      {/*<Route path="l1_issuers/*" element={<L1Issuers />} />*/}
      <Route path="l1_events/*" element={<L1Events />} />
      <Route path="l1_portfolios/*" element={<L1Portfolios />} />
      <Route path="l1_static_data/*" element={<L1StaticData />} />
      <Route path="l1_time_series/*" element={<L1TimeSeries />} />
      <Route path="l1_transactions/*" element={<L1Transactions />} />
      <Route path="l1_bank_positions/*" element={<L1BankPositions />} />
      <Route path="l1_data_upload/*" element={<L1DataUpload />} />
    </Routes>
  );
}
